
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import {IPage} from "@/js/page";
    import {authorizeCertApi, dictApi, measuringStandardApi, userApi} from "@/api/organization";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import {Param} from "@/js/ParamList";
    import baseUrl from "@/constants";
    import InspectionArchives from "@/components/examine/InspectionArchives.vue";
    import {agingStateList} from "@/js/checkType";
import TableShowRangeBodyEjian from "@/components/table-show-range-body-ejian.vue";
    const {regionData, CodeToText} = require("@/js/region/region");
    @Component({
        name: 'measuringListV2',
        components: {
          TableShowRangeBodyEjian,
          SetTableColumns, TableShowRangeHead, TableShowRangeBody, InspectionArchives}
    })
    export default class MeasuringListV2 extends Vue {
        @Prop()
        propQuery: any;

        @Prop()
        tableHeight: any;

        mode = ""; //This_Unit 本单位， This_Area 本区域， Examine 审核，Share 共享
        modeValue = "";//ALL 所有,CUR 当前,HIS 历史
        orgId = "";
        modeType = "Standard"; //Standard：计量标准 Devices：计量标准器  Equipment：配套设备 Item：授权项目 ShareStandard: 已共享的计量标准
        CodeToText = CodeToText;
        regionData = regionData;
        agingStateList = agingStateList; //现行状态
        private exportExcel: any;
        private timeContrast: any;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        showForm = false;//查询条件隐藏展示
        load = false;//加载
        dataList = []; //数据列表
        mechanismTypeList = [];//单位类型字典
        tabCol = [];
        allSelected = [];//列表选中数据
        sysMeasuringUpdate = false; //是否有审核权限
        propParams = this.getPropParams();
        total = 0;
        itemDialog = {
            visible: false,
            modeType: "",
            measuringId: 0,
            loading: false,
            dataList: [],
        }
        surveyRangesDialog = {
            visible: false,
            paramList: [] as any
        }
        selectStandard = {
            visible: false,
            addMode: '',//添加模式
            loading: false,
            list: [],// 选中的数据
            dataList: [],//数据列表
            current: -1,
            standardName: '', // 标准名称
            certificateNo: '',// 证书编号

        }
        listParam: IPage = {
            size: 50,
            current: 1,
        };
        inspectionParams = {
            instrumentsId: 0,
        };
        //追溯信息弹框
        reviewInfoDialog = {
            visible: false,
        }
        showItemDialog(mType: string, measuringId: number){
            let modeType = "Devices";
            switch (mType) {
                case "devicesNum": {
                    modeType = "Devices";
                    break;
                }
                case "equipmentNum":{
                    modeType = "Equipment";
                    break;
                }
                case "itemNum": {
                    modeType = "Item";
                    break;
                }
            }
            this.itemDialog.visible = true;
            this.itemDialog.loading = true;
            this.itemDialog.modeType = modeType;
            this.getMeasuringList(modeType, measuringId,(dataList: any) => {
                this.itemDialog.dataList = dataList;
                this.itemDialog.loading = false;
            });
        }

        query(){
            this.selectStandard.loading = true;
            let API = measuringStandardApi.listUnReplaceStandard({standardName: this.selectStandard.standardName, certificateNo: this.selectStandard.certificateNo});
            API.then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.selectStandard.dataList = rData;
                }
                this.selectStandard.loading = false;
            });
        }

        closeReviewDialog (){
            this.inspectionParams.instrumentsId = 0;
            this.reviewInfoDialog.visible = false;
        }
        openReviewInfo(row: any){
            this.inspectionParams.instrumentsId = row.instrId;
            this.reviewInfoDialog.visible = true;
        }

        getFixedTableColumn(){
            const { modeType } = this.itemDialog;
            if(modeType === 'Devices' || modeType === 'Equipment'){
                return [
                    {name: "标准器名称", show: true, prop: "instrName", width: 140},
                    {name: "唯一标识", show: true, prop: "instrNo", width: 140},
                    {name: "测量范围", show: true, prop: "surveyRanges", width: 110},
                    {name: "规格型号", show: true, prop: "modelSpecific", width: 120},
                    {name: "专业类别", show: true, prop: "majorName", width: 110},
                    {name: "器具种别", show: true, prop: "className", width: 110},
                    {name: "器具项别", show: true, prop: "categoryName", width: 110},
                    {name: "制造单位", show: true, prop: "manufactoryName", width: 230},
                    {name: "出厂编号", show: true, prop: "serialNumber", width: 120},
                ]
            }else{
                return [
                    {name: "检定/校准项目名称", show: true, prop: "itemName", width: 180},
                    {name: "测量范围", show: true, prop: "surveyRanges", width: 110},
                    {name: "依据的规程规范编号", show: true, prop: "ruleNumber", width: 180},
                    {name: "依据的规程规范名称", show: true, prop: "ruleName", width: 180},
                    {name: "计量标准考核证书编号", show: true, prop: "certificateNo", width: 190},
                    {name: "计量标准名称", show: true, prop: "standardName", width: 180},
                ]
            }
        }

        getMeasuringList(modeType: string, measuringId: number, callback: any) {
            const params = {
                mode: "ALL",
                modeValue: "ALL",
                orgId: this.orgId,
                current: -1,
                measuringId: measuringId,
            } as any;
            let API = null;
            if (modeType == "Devices") {
                params.itemType = 0;
                API = measuringStandardApi.pageDevicesV2(params);
            } else if (modeType == "Equipment") {
                params.itemType = 1;
                API = measuringStandardApi.pageDevicesV2(params);
            } else {
                API = measuringStandardApi.pageItemsV2(params);
            }
            API.then((r: any) => {
                if(r.data.result === 0){
                    callback(r.data.data.records);
                }
            });
        }

        getPropParams() {
            return {
                standardCode: '',//计量标准代码
                standardName: '',// 计量标准名称
                status: '',// 审核状态 0:待提交 1:未审核  2:已生效  3:未通过
                manageStatus: '', //添加方式 0新增 1复查 2 改造 3 初始
                useStatus: '',// 使用状态：1.在用 2.暂停 3.封存 4.撤销
                itemName: '', //检定/校准名称
                shareStatus: '', //共享状态
                agingStatus: '', //时效状态
                organizationType: '', //单位类型
                organizationName: '', //建标单位
                organizationRegion: '',//所在区域
                certificateNo: '',//考核证书号
                issuingAuthority: '',//发证机关
                issuedDate: '',//发证日期
                issuedDateEnd: '',//发证日期结束
                termValidity: '',//有效期
                termValidityEnd: '',//有效期结束
                instrNo: '', // 唯一标识
                instrName: '',// 器具名称
                majorName: '',// 专业类别
                className: '',// 器具种别
                categoryName: '',// 器具项别
                manufactoryName: '',// 制造单位
                serialNumber: '',// 出厂编号
                firstCreatedYear: '', //首次建标年份
            }
        }

        created() {
            this.haveRight();
            this.listOrganizationTypeName();
            this.init();
        }
        handleCommand(command: string){
          console.log(command);
          switch (command) {
                case "NEW" : {
                    this.toDetail('Add');
                    break;
                }
                case "ORIGINAL": {
                    this.toDetail("ORIGINAL_ADD");
                    break;
                }
                case "RESET" : {
                    this.openSelectStandard('RESET_ADD');
                    break;
                }
                case "REFORM": {
                    this.openSelectStandard('REFORM_ADD');
                    break;
                }
                case "REVIEW" : {
                    this.openSelectStandard('REVIEW_ADD');
                    break;
                }
            }
        }

        openSelectStandard(addMode: string){
            this.selectStandard.addMode = addMode;
            this.selectStandard.list = [];
            this.selectStandard.certificateNo = "";
            this.selectStandard.standardName = "";
            this.selectStandard.dataList = []
            this.selectStandard.visible = true;
            this.query();
        }
        memberSelectV2(selection: any, row: any) {
            this.selectStandard.list = selection;
        }

        goCustomAddDetail(){
            const addMode = this.selectStandard.addMode;
            const dataArr = this.selectStandard.list;
            if (dataArr.length == 0) {
                this.$message.error("请先勾选");
                return;
            }
            if (dataArr.length > 1) {
                this.$message.error("只能勾选一条");
                return;
            }
            this.selectStandard.visible = false;
            const cur = dataArr[0] as any;
            this.goDetail(addMode, cur.id, 0);
        }

        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.init();
            }
            this.tableClearSelect();
        }

        reset() {
            this.propParams = this.getPropParams();
            this.refresh();
        }

        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }

        init() {
          if (this.propQuery) {
            const q = this.propQuery
            if (q.size) {
              this.listParam.size = Number(q.size);
              this.listParam.current = Number(q.current);
            }
            this.mode = q.mode
            this.modeValue = q.modeValue;
            if(q.modeType){
              this.modeType = q.modeType;
            }
            if (q.agingStatus) {
              this.propParams.agingStatus = q.agingStatus;
            }
            let orgId = q.orgId;
            if(orgId && orgId !== '0' && orgId !== ''){
              this.orgId = orgId;
            }
          } else {
            const route = this.$route;
            const q = JSON.parse(JSON.stringify(route.query));
            if (q.size) {
              this.listParam.size = Number(q.size);
              this.listParam.current = Number(q.current);
            }
            this.mode = this.$route.params.mode
            this.modeValue = this.$route.params.modeValue;
            if(this.$route.params.modeType){
              this.modeType = this.$route.params.modeType;
            }
            let orgId = this.$route.params.orgId;
            if(orgId && orgId !== '0' && orgId !== ''){
              this.orgId = orgId;
            }
          }
          this.loadData(null);
        }

        closeSurveyRangesDialog() {
            this.surveyRangesDialog.paramList = [] as Param[];
            this.surveyRangesDialog.visible = false;
        }

        openSurveyRangesDialog(surveyRanges: string) {
          // this.surveyRangesDialog.paramList = this.parseParamList(surveyRanges);
            this.surveyRangesDialog.paramList = surveyRanges;
            this.surveyRangesDialog.visible = true;
        }

        getTableColumns() {
            if (this.modeType === 'Standard' || this.modeType === 'ShareStandard') {
                return "Standard";
            } else if (this.modeType === 'Equipment' || this.modeType === 'Devices') {
                return "Devices";
            } else if (this.modeType === 'Item') {
                return "Item";
            }
            return "";
        }

        getTitle() {
            if (this.mode === 'This_Unit' && this.modeValue === 'ALL') {
                if(this.orgId){
                    return "当前单位全部计量标准";
                }else{
                    return "本单位全部计量标准";
                }
            } else if (this.mode === 'This_Unit' && this.modeValue === 'CUR') {
                return "本单位当前计量标准";
            } else if (this.mode === 'This_Unit' && this.modeValue === 'HIS') {
                return "本单位历史计量标准";
            } else if (this.mode === 'This_Area' && this.modeValue === 'ALL') {
                return "本区域全部计量标准";
            } else if (this.mode === 'This_Area' && this.modeValue === 'CUR') {
                return "本区域当前计量标准";
            } else if (this.mode === 'This_Area' && this.modeValue === 'HIS') {
                return "本区域历史计量标准";
            } else if (this.mode === 'Share') {
                return "本区域当前计量标准";
            } else {
                return "";
            }
        }

        hasBtn(mode: string) {
            if (mode === 'Add') {
                return this.mode === 'This_Unit' && this.modeType === 'Standard' && this.modeValue === 'ALL' && this.orgId == "";
            } else if (mode === 'Excel') {
                return true;
            } else if (mode === 'Look') {
                return this.modeType === 'Standard' || this.modeType === 'ShareStandard';
            } else if (mode === 'Edit') {
                return (this.mode === 'This_Unit' && this.modeType === 'Standard' && this.modeValue === 'ALL' && this.orgId == "")
                    || (this.mode === 'This_Area' && this.modeType === 'Standard' && this.modeValue === 'ALL' && this.orgId == "" && this.sysMeasuringUpdate)
            } else if (mode === 'Submit') {
                return this.mode === 'This_Unit' && this.modeType === 'Standard' && this.modeValue === 'ALL' && this.orgId == "";
            } else if (mode === 'Del') {
                return (this.mode === 'This_Unit' && this.modeType === 'Standard' && this.modeValue === 'ALL' && this.orgId == "")
                || (this.mode === 'This_Area' && this.modeType === 'Standard' && this.modeValue === 'ALL' && this.orgId == "" && this.sysMeasuringUpdate);
            } else if (mode === 'Examine') {
                return this.mode === 'Examine' && this.modeType === 'Standard' && this.sysMeasuringUpdate;
            } else if (mode === 'Share') {
                return this.mode === 'Share';
            } else if (mode === 'Release') {
                return this.mode === 'Share' && this.modeType === 'Standard';
            } else if (mode === 'Recall') {
                return this.mode === 'Share' && this.modeType === 'ShareStandard';
            }else if(mode === 'close'){
                return this.orgId;
            }else if(mode === 'Revoke') {
                return (this.mode === 'This_Area' && this.modeType === 'Standard' && this.modeValue === 'ALL' && this.orgId == "" && this.sysMeasuringUpdate)
            }
            return false;
        }

        loadData(callback: any) {
            this.tableClearSelect();
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q, this.listParam);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            const params = {
                mode: this.mode,
                modeValue: this.modeValue,
                orgId: this.orgId,
                ...this.listParam,
                ...this.propParams,
            } as any;
            this.load = true;
            let API = null;
            if (this.modeType == "Standard") {
                API = measuringStandardApi.pageV2(params);
            } else if (this.modeType == "Devices") {
                params.itemType = 0;
                API = measuringStandardApi.pageDevicesV2(params);
            } else if (this.modeType == "Equipment") {
                params.itemType = 1;
                API = measuringStandardApi.pageDevicesV2(params);
            } else if (this.modeType == "ShareStandard") {
                params.shareStatus = 1;
                API = measuringStandardApi.pageV2(params);
            } else {
                API = measuringStandardApi.pageItemsV2(params);
            }
            API.then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.total = r.data.data.total;
                    this.dataList = rData;
                    if (callback) {
                        callback();
                    }
                    this.$nextTick(() => {
                        let $table = this.$refs.table as HTMLFormElement;
                        if ($table) {
                            $table.doLayout();
                        }
                        this.load = false;
                    })
                }
            });
        }

        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }

        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(() => {
                let $table = this.$refs.table as HTMLFormElement;
                if ($table) {
                    $table.doLayout();
                }
            })
        }

        haveRight() {
            const right = this.$store.state.userRights;
            right.forEach((e: any) => {
                if (e.name == "计量标准审核") {
                    this.sysMeasuringUpdate = true;
                }
            })
        }

        toDetail(type: string) {
            const dataArr = this.allSelected as any;
            let id = 0;
            if (['Add', 'ORIGINAL_ADD'].indexOf(type) === -1) {
                if (dataArr.length == 0) {
                    this.$message.error("请先勾选");
                    return;
                }
                if (type === 'Return') {
                    this.batchReturn(dataArr);
                    return;
                }
                if(type === 'Revoke'){
                    this.batchRevoke(dataArr);
                    return;
                }
                if (type === 'Release' || type == "Recall") {
                    this.batchReleaseOrRecall(dataArr, type);
                    return;
                }
                if (type == 'Del') {
                    this.batchDelete(dataArr);
                    return;
                }

                if (dataArr.length > 1 && (type == 'Look' || type == 'Edit' || type == 'Examine')) {
                    this.$message.error("只能勾选一条");
                    return;
                }
                if (type == 'Submit') {
                    const data = dataArr.filter((d: any) => d.status.value === 2);
                    if (data.length > 0) {
                        const names = data.flatMap((e: any) => e.name).join(",");
                        this.$message.error("您选择的 【" + names + "】已通过，无法进行提交！");
                        return;
                    }
                    this.batchSubmit(dataArr);
                    return;
                }
                if (type == 'Edit') {
                    this.toEdit(dataArr[0], type);
                    return;
                }
                if(type == 'Examine'){
                    this.goDetail(type, dataArr[0].id , dataArr[0].manageStatus.value);
                    return;
                }
                id = dataArr[0].id;
            }
            this.goDetail(type, id, 0);
        }

        batchDelete(dataArr: any){
            this.$confirm('您勾选了:  ' + dataArr.length + '条计量标准，是否删除', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                measuringStandardApi.delete({ids: dataArr.flatMap((e:any)=>e.id).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.loadData(null);
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

        goDetail(type: string, id: number, manageStatus: number) {
            const firstRouterText = this.$route.path.split("/")[1];
            let mode = 0, pageType = 0;
            if (this.mode === 'This_Unit') {
                mode = 0;
            } else if (this.mode === 'This_Area') {
                mode = 1;
            } else if (this.mode === 'Examine') {
                mode = 2;
            } else if (this.mode === 'Share') {
                mode = 1;
            }
            if (type === 'Add') {
                pageType = 0;
            } else if (type === 'Look') {
                pageType = 2;
            } else if (type === 'Examine') {
                pageType = 4;
            } else if (type === 'Edit') {
                pageType = 1;
            }else if(type === 'REVIEW_ADD'){
                pageType = 0;
                manageStatus = 1;
            }else if(type === 'REFORM_ADD'){
                pageType = 0;
                manageStatus = 2;
            }else if(type === 'ORIGINAL_ADD'){
                pageType = 0;
                manageStatus = 3;
            }else if(type === 'RESET_ADD'){
                pageType = 0;
                manageStatus = 4;
            }
            this.$router.push("/" + firstRouterText + "/measuring/detail/" + pageType + "/" + mode + "/" + manageStatus +"/" + id);
        }

        toEdit(data: any, type: string) {
          measuringStandardApi.checkEdit(data.id).then((r: any) => {
            if (r.data.result === 0) {
             const status = r.data.data;
              if (status === 2) {
                this.$confirm('您勾选的是审核“已通过”的计量标准，只允许对部分内容进行编辑，且编辑并保存后需要重新提交审核，是否继续编辑？', '提示', {
                  confirmButtonText: '是',
                  cancelButtonText: '否',
                  type: 'warning',
                  dangerouslyUseHTMLString: true
                }).then(() => {
                  this.goDetail(type, data.id, data.manageStatus.value);
                });
              } else {
                this.goDetail(type, data.id, data.manageStatus.value);
              }
            }
          })
        }
      batchReleaseOrRecall(dataArr: any, type: string) {
        const str = type == 'Release' ? '发布' : '撤回';
        this.$confirm('您勾选了:  ' + dataArr.length + '条计量标准，是否' + (str) + '？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          const loading = this.$loading({
            text: `正在${str}，请等待...`,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          measuringStandardApi.updateShare(dataArr.flatMap((e: any) => e.id).join(","), (type === 'Release' ? 1 : 2)).then(r => {
            loading.close();
            if (r.data.result === 0) {
              this.$message.success((str + "成功！"));
              this.loadData(null);
            }

          })
        })
      }
        batchRevoke(dataArr: any){
            this.$confirm('确定要撤销计量标准名称为:  ' + dataArr.flatMap((e: any) => e.name).join(",") + '？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                authorizeCertApi.updateStatus({ids: dataArr.flatMap((e: any) => e.id).join(","), status: 0, reason: '', type: 1}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("撤销成功");
                        this.loadData(null);
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        batchReturn(dataArr: any) {
            this.$confirm('您勾选了:  ' + dataArr.length + '条计量标准，是否退回？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                authorizeCertApi.updateStatus({
                    ids: dataArr.flatMap((e: any) => e.id).join(","),
                    status: 0,
                    reason: '',
                    type: 1
                }).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("退回成功");
                        this.loadData(null);
                    }
                })
            })
        }

        batchSubmit(dataArr: any) {
            this.$confirm('您勾选了' + dataArr.length + '条计量标准，是否提交审核？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                authorizeCertApi.updateStatus({
                    ids: dataArr.flatMap((e: any) => e.id).join(","),
                    status: 1,
                    reason: '',
                    type: 1
                }).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("提交成功");
                        this.refresh();
                    }
                })
            })
        }

        refresh() {
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
            this.loadData(null);
        }

        listOrganizationTypeName() {
            dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
                if (r.data.result === 0) {
                    this.mechanismTypeList = r.data.data;
                }
            });
        }

        getOrganizationTypeName(organizationTypes: string) {
            const arr = organizationTypes ? organizationTypes.split(",") : [];
            const arr2 = [] as any;
            arr.forEach((e: any) => {
                const obj = this.mechanismTypeList.find((e2: any) => e2.dictKey === e) as any;
                if (obj) {
                    arr2.push(obj.dictValue);
                }
            })
            return arr2.length > 0 ? arr2.join("，") : "-";
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.loadData(null);
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        down(row: any) {
            try {
                const obj = JSON.parse(row);
                if (typeof obj == 'object' && obj) {
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=计量标准证书影印件", '_blank');
                return false;
            }
        }

        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const listParam = JSON.parse(JSON.stringify(this.listParam));
            this.listParam.size = this.total;    //将表格长度变成数据总长度
            this.listParam.current = 1;          //显示第一页
            this.loadData(() => {
                this.exportExcel(() => {
                    this.listParam = listParam;    //表格长度还原
                    this.loadData(null);
                    loading.close();
                }, "计量标准列表.xlsx");
            });

        }

        parseParamList(jsonString: string) {
            if (jsonString) {
                return JSON.parse(jsonString);
            } else {
                return [] as Param[];
            }
        }
    }
